import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
      legend = _ref.legend;
  var getClassName = getClassNameFactory(Fieldset.displayName);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: getClassName()
  }, legend && /*#__PURE__*/React.createElement("legend", {
    className: getClassName({
      descendantName: "legend"
    })
  }, legend), children);
};

Fieldset.displayName = "Form.Fieldset";
Fieldset.propTypes = {
  /**
   * Form controls composition
   */
  children: PropTypes.node.isRequired,

  /**
   * Optional legend for the fieldset (bolding supported with `<b>`)
   */
  legend: PropTypes.node
};
export default Fieldset;